<template>
  <div>
    <van-popup v-model="isShowFilter" position="bottom">
      <div class="main">
        <div class="main-title df jc-sb">
          <div class='df '>
            <div class="title-img">
              <img v-if="previewPicUrl" class="goods-img" :src="previewPicUrl" mode="scaleToFill" />
            </div>
            <div class="goods-price" >
              <div class="symbol" v-show="goodsPrice != '价格详谈'">¥</div>
              <div>{{goodsPrice}}</div>
            </div>
          </div>
          <div>
            <img class="close-img" @click="goBack" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/icons/close_black.png" mode="scaleToFill"/>
          </div>
        </div>
        <div class="main-list" v-for="(item,index) in specList" :key="index">
          <div class="title">{{item.title}}</div>
          <div class="spec">
            <div class='spec-item' v-for="(its,index) in item.list"  :key="index">
              <span class="spec-name" @click="changeSpec(item, its, its.able)" :class="[selectSpec[item.title] === its.name ? 'active' : 'cancelActive' , its.able? '' : 'disabled']">{{its.name}}</span>
            </div>
          </div>
        </div>
        <div class="save" @click="save">确认</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data(){
    return{
      isShowFilter: false,
      // goodsDetail:{},
      goodInfo:{},
      // sku展示列表初始化
      specList:[],
      // sku展示列表
      specSkuList:[],
      // sku选择列表
      skuList:[],
      // 选中的展示列表
      selectSpec:{},
      // 选中的数据
      selectInfo:{},
      minPrice:'',
    }
  },
  computed: {
    previewPicUrl(){
      return this.selectInfo.previewPicUrl ? this.selectInfo.previewPicUrl : this.goodInfo.previewPicUrl
    },
    goodsPrice() {
      return this.selectInfo.price || this.minPrice
    }
  },
  methods: {
    changeShow(config){
      this.goodInfo = config.goodsInfo
      this.selectInfo = config.selectInfo
      this.specSkuList = config.goodsInfo.sellerProductSkuDisplayDtoList
      this.skuList = config.goodsInfo.sellerProductSkuChooseDtoList
      const specList = config.goodsInfo.sellerProductSkuDisplayDtoList
      this.miniPrice()
      specList.forEach(item => {
        this.$set(this.selectSpec,item.skuCatalogue,"");
      })
      this.specList = specList.map(item => {
        return {
          title:item.skuCatalogue,
          list: item.attributeList.map(its => {
            return {
              name:its,
              // 判断是否可以选择
              able: this.isAble(item.skuCatalogue, its)   
            }
          })
        }
      })
      // sku回显
      const skuInfo = {...this.selectInfo.attributeList}
      Object.keys(this.selectSpec).forEach((el,index)=>{
        this.selectSpec[el] = skuInfo[index] || ""
      })
      for(let i in skuInfo){
        if(skuInfo[i]){
          this.changeNewSpec()
        }
      }
      this.changeSpec()

      this.isShowFilter = !this.isShowFilter;
    },

    // 最低价
    miniPrice(){
      let priceStr = '价格详谈'
      /** 判断当前是否有谱价格详谈 */
      const noPrice = this.skuList.some(el => !el.price)
      /** 判断是否是最低价格 */
      if(!noPrice) {
        const arr = this.skuList.map(el => el.price).sort((a, b) => a-b)
        priceStr = `${arr[0]}起`
      }
      this.minPrice = priceStr
    }, 

    // 点击事件
    changeSpec(item,its,able){
      if(!able) return
      if(this.selectSpec[item.title] === its.name){
        this.selectSpec[item.title] = ''
      }else {
        this.selectSpec[item.title] = its.name
      }
      this.changeNewSpec()
      this.findSpec()
    },

    // 选中之后重新遍历数组
    changeNewSpec(){
      // forEach循环改变原数组
      this.specList.forEach(item => {
        item.list.forEach(its => {
          its.able = this.isAble(item.title, its.name);
        });
      });
    },
    // 在选则列表中查询
    findSpec(){
      this.selectInfo = this.skuList.find((item) => {
        return JSON.stringify(item.attributeList) == JSON.stringify(Object.values(this.selectSpec))
      }) || {}
    },
    
    save(){
      // 选中的数组
      const spec =Object.entries(this.selectSpec).reverse()
      // 选中数组的key值
      const judge= Object.values(this.selectSpec).filter(el => el == "")
      // 要么全选，要么全不选
      if(judge.length == 0 || judge.length == spec.length){
        const params = {
        ...this.selectInfo,
        attributeList: Object.values(this.selectSpec),
        skuNo: judge.length == spec.length ? "" : this.selectInfo.skuNo,
        price: this.selectInfo.price ? this.selectInfo.price : this.goodsPrice
      }
      this.$emit('skuChange',params)
      this.isShowFilter = !this.isShowFilter;
      return
      }
      spec.forEach((el)=>{
        if(el[1] == ""){
          this.$toast(`请选择${el[0]}`)
          return;
        }
      })
    },
    goBack() {
      this.isShowFilter = false
    },


    // 判断规格是否可以被选择  核心函数 key当前的规格的title   value规格值
    isAble(key, value){
      // 深拷贝 避免被影响  
      var copySelectSpec = JSON.parse(JSON.stringify(this.selectSpec));
      // 用对象的好处就在这了 直接赋值当前验证项
      copySelectSpec[key] = value;
      // 用数组的 some 方法 效率高 符合条件直接退出循环
      let flag = this.skuList.some(item => {
        // 条件判断 核心逻辑判断
        var i = 0 ; 
        // 这个for in 循环的逻辑就对底子不深的人来说就看不懂了 原理就是循环已经选中的 和 正在当前对比的数据 和 所有的sku对比 只有当前验证的所有项满足sku中的规格或者其他规格为空时 即满足条件 稍微有点复杂 把注释的调试代码打开就调试下就可以看懂了
        for(let k in copySelectSpec) {
          if(copySelectSpec[k] != "" && item.attributeList.includes(copySelectSpec[k])){
            i++
          }else if (copySelectSpec[k] == "") {
            i++;
          }
        }
        // 符合下面条件就退出了 不符合会一直循环知道循环结束没有符合的条件就 return false 了 
        return i == this.specSkuList.length
      })
      return flag
    },
  }
}
</script>

<style lang="less" scoped>
.main-title{
  padding: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  .title-img{
    height: 120px;
    width: 120px;
    margin-right: 24px;
    .goods-img{
      width: 120px;
      height: 120px;
    }
  }
  .goods-price{
    font-size: 54px;
    color: #F23E7E;
    font-weight: bold;
    margin-top: 20px;
    display: flex;
    .symbol{
      font-size:30px;
      margin-top: 22px;
      margin-right: 5px;
    }

  }
  .close-img{
    width: 50px;
    height: 50px;
  }
}
.main-list{
  padding: 20px;
  // width:100%;
  .title{
    font-size: 32px;
    font-weight: bold;
  }
  .spec{
    width: 700rpx;
    display: flex;
    flex-wrap: wrap;
    .spec-item{
      .spec-name {
        margin-top: 20px;
        display: inline-block;
        white-space: nowrap;
      }
      
    }
  }
}
.disabled,
.active,
.cancelActive{
  margin-right: 20px;
  padding: 2px 16px;
  border-radius: 10px;
  min-width: 50px;
  text-align: center;
  
}
.cancelActive{
  background-color: #eee;
  border: 1px solid #eee;
  color: #101010;
}
.active{
  background-color: rgba(251,39,118,0.1) ;
  color: #F23E7E;
  border: 1px solid #F23E7E;
}
.disabled{
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #ebeef5;
}
.df{
  display: flex
}
.jc-sb{
  justify-content:space-between
}
.save{
  background-color: #f23e7e;
  text-align: center;
  color: #fff;
  padding:30px;
  margin: 30px;
  border-radius: 50px;
}
</style>